import { useTranslation } from "react-i18next";
import React, { useCallback } from "react";
import { CONTENT_MANAGEMENT_ID } from "@duosoftbg/nacid-components";
import { Alert } from "@mui/material";
import useViewDataObject from "../../../../../hooks/redux/useViewDataObject";
import { getContentManagementDataById } from "../../../../../axios/api/services";
import PageWrapper from "../../../../components/common/layout/PageWrapper";
import { VIEW_TYPES } from "../../../../../config/view/types";
import SitemapEditList from "./SitemapEditList";
import styled from "styled-components";
import TableCell from "@mui/material/TableCell";
import ViewPageWrapper from "../../../contacts/ViewPageWrapper";

export const SitemapEmptyListAlert = styled(Alert)`
  padding-top: 1px;
  padding-bottom: 1px;
  background: white;
  border: 1px solid #d8d8d8;
  border-top: 0px;
`;

export const SitemapButtonTableCell = styled(TableCell)`
  text-align: right;
  width: 80px;
`;

const SiteMapEdit = () => {
  const { t } = useTranslation();

  const viewType = VIEW_TYPES.SITEMAP_EDIT;
  const { object, data: siteMap } = useViewDataObject(viewType);
  const serviceFn = useCallback(getContentManagementDataById(CONTENT_MANAGEMENT_ID.SITEMAP), []);

  return (
    <PageWrapper title={t("t.page.sitemap.edit")}>
      <ViewPageWrapper viewType={viewType} serviceFn={serviceFn} object={object}>
        {siteMap && <SitemapEditList siteMap={siteMap}></SitemapEditList>}
      </ViewPageWrapper>
    </PageWrapper>
  );
};

export default SiteMapEdit;
